module.exports = __webpack_public_path__ + "assets/img/tcc.bb5d643f.png";